import '@qonsoll/react-design/dist/styles/antd/index.css'
import '@qonsoll/react-design/dist/styles/vars/index.css'
import './styles/styles.css'

import App from './App'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { ROUTER_BASE_PATH } from 'configs/routerBasePath'
import { UserProvider } from 'domains/User/context'
import { recordDashboardPerformanceMetric } from 'helpers/performance'
import reportWebVitals from './reportWebVitals'

ReactDOM.render(
  <Router basename={ROUTER_BASE_PATH}>
    <UserProvider>
      <App />
    </UserProvider>
  </Router>,
  document.getElementById('root')
)

reportWebVitals((metric) => {
  recordDashboardPerformanceMetric({
    name: 'web-vital',
    detail: {
      id: metric.id,
      metricName: metric.name,
      delta: metric.delta
    },
    duration: metric.value,
    report: true
  })
})
